import React from 'react';

import { Icon } from '@chakra-ui/react';
import {
  MdHome,
  MdPerson,
  MdWallet,
  MdBarChart,
  MdLocationOn,
  MdMoney,
  MdCreditCard,
  MdDialpad,
  MdApi,
} from 'react-icons/md';

import Dashboard from 'views/admin/dashboard';
import Networks from 'views/admin/networks';
import Wallets from 'views/admin/wallets';
import Fiat from 'views/admin/fiat';
import Cards from 'views/admin/cards';
import Account from 'views/admin/account';
import constants from 'providers/Constants';

import NFTMarketplace from 'views/admin/marketplace';
import MainDashboard from 'views/admin/default';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import SignUpCentered from 'views/auth/signUp';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/dashboard',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
    component: <Dashboard />,
  },
  {
    name: 'Networks',
    layout: '/admin',
    path: '/networks',
    icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit" />,
    component: <Networks />,
  },
  {
    name: 'Crypto Wallets',
    layout: '/admin',
    path: '/wallets',
    icon: <Icon as={MdWallet} width="20px" height="20px" color="inherit" />,
    component: <Wallets />,
  },
  {
    name: 'Fiat Wallets',
    layout: '/admin',
    path: '/fiat',
    icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit" />,
    component: <Fiat />,
  },
  {
    name: 'Payment Cards',
    layout: '/admin',
    path: '/cards',
    icon: <Icon as={MdCreditCard} width="20px" height="20px" color="inherit" />,
    component: <Cards />,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/account',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    component: <Account />,
  },
  {
    name: 'API Reference',
    layout: '/admin',
    path: constants.urls.documentation,
    icon: <Icon as={MdApi} width="20px" height="20px" color="inherit" />,
    external: true,
  },
];

export default routes;
